module.exports = __webpack_public_path__ + "img/classiccar.07ece6e4.webp";